import { render, staticRenderFns } from "./ManuscriptPreview.vue?vue&type=template&id=141a6954&scoped=true"
import script from "./ManuscriptPreview.vue?vue&type=script&lang=ts"
export * from "./ManuscriptPreview.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptPreview.vue?vue&type=style&index=0&id=141a6954&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141a6954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141a6954')) {
      api.createRecord('141a6954', component.options)
    } else {
      api.reload('141a6954', component.options)
    }
    module.hot.accept("./ManuscriptPreview.vue?vue&type=template&id=141a6954&scoped=true", function () {
      api.rerender('141a6954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ManuscriptPreview.vue"
export default component.exports